import { IGame } from "./game.model";

class GameStore {

  games: IGame[] = [
    {
      id: 1,
      name: '7 Hot Fruits',
      uniqueName: '7-hot-fruits',
    },
    {
      id: 5,
      name: '7 Hot Fruits - 5 Lines',
      uniqueName: '7-hot-fruits-5-lines',
    },
    {
      id: 14,
      name: 'Alchemist\'s Laboratory',
      uniqueName: 'alchemists-laboratory',
    },
    {
      id: 31,
      name: 'Avia Plane',
      uniqueName: 'avia-plane',
    },
    {
      id: 52,
      name: 'Avia Plane',
      uniqueName: 'branded-avia-plane',
    },
    {
      id: 26,
      name: 'Avia Rush',
      uniqueName: 'avia-rush',
    },
    {
      id: 3,
      name: 'Aztec Enigma',
      uniqueName: 'aztec-enigma',
    },
    {
      id: 22,
      name: 'Beach Bar Bonanza',
      uniqueName: 'beach-bar-bonanza',
    },
    {
      id: 34,
      name: 'Beer Crash',
      uniqueName: 'beer-crash',
    },
    {
      id: 29,
      name: 'Branded Chicken Crash',
      uniqueName: 'branded-chicken-crash',
    },
    {
      id: 10,
      name: 'Caramel Crush',
      uniqueName: 'caramel-crush',
    },
    {
      id: 23,
      name: 'Chicken Crash',
      uniqueName: 'chicken-crash',
    },
    {
      id: 25,
      name: 'Chicken Crash Snowstorm',
      uniqueName: 'chicken-crash-snowstorm',
    },
    {
      id: 42,
      name: 'Chicken Crown',
      uniqueName: 'chicken-crown',
    },
    {
      id: 41,
      name: 'Chick or Crack',
      uniqueName: 'chick-or-crack',
    },
    {
      id: 37,
      name: 'Christmas Chicken Crash',
      uniqueName: 'christmas-chicken-crash',
    },
    {
      id: 43,
      name: 'Flappy Rise',
      uniqueName: 'flappy-rise',
    },
    {
      id: 21,
      name: 'Halloween Reels',
      uniqueName: 'halloween-reels',
    },
    {
      id: 35,
      name: 'Hallow Jet',
      uniqueName: 'hallow-jet',
    },
    {
      id: 33,
      name: 'Heracles Treasures',
      uniqueName: 'heracles-treasures',
    },
    {
      id: 9,
      name: 'Keno 10',
      uniqueName: 'keno-10',
    },
    {
      id: 8,
      name: 'Keno 8',
      uniqueName: 'keno-8',
    },
    {
      id: 15,
      name: 'Limbo',
      uniqueName: 'limbo',
    },
    {
      id: 28,
      name: 'Limbo Galaxy',
      uniqueName: 'limbo-galaxy',
    },
    {
      id: 16,
      name: 'Mines',
      uniqueName: 'mines',
    },
    {
      id: 36,
      name: 'Neo Crash',
      uniqueName: 'neo-crash',
    },
    {
      id: 2,
      name: 'Neo Vegas',
      uniqueName: 'neo-vegas',
    },
    {
      id: 11,
      name: 'Plinko',
      uniqueName: 'plinko',
    },
    {
      id: 27,
      name: 'Plinko of The Sun God',
      uniqueName: 'plinko-of-the-sun-god',
    },
    {
      id: 24,
      name: 'Roulette',
      uniqueName: 'roulette',
    },
    {
      id: 7,
      name: 'Royal Gold Rush',
      uniqueName: 'royal-gold-rush',
    },
    {
      id: 6,
      name: 'Samurai Spin',
      uniqueName: 'samurai-spin',
    },
    {
      id: 12,
      name: 'Santa\'s Reels',
      uniqueName: 'santas-reels',
    },
    {
      id: 40,
      name: 'Tower Crash',
      uniqueName: 'tower-crash',
    },
    {
      id: 39,
      name: 'Twist',
      uniqueName: 'twist',
    },
    {
      id: 38,
      name: 'Twist Christmas',
      uniqueName: 'twist-christmas',
    },
    {
      id: 30,
      name: 'Victory Crown',
      uniqueName: 'victory-crown',
    },
    {
      id: 17,
      name: 'Wheel',
      uniqueName: 'wheel',
    },
    {
      id: 40,
      name: 'Tower Crash',
      uniqueName: 'tower-crash',
    },
  ];

}

export const gameStore = new GameStore();
